<div class="container page-container">

  <evland-breadcrumbs [items]="breadcrumbs"></evland-breadcrumbs>

  <h1 i18n>Договір публічної оферти про надання послуг</h1>

  <ng-container i18n>
    <p><strong>ТОВАРИСТВО З ОБМЕЖЕНОЮ ВІДПОВІДАЛЬНІСТЮ «ЧАРДЖ СПАЙ»</strong> (надалі «Виконавець»), код ЄДРПОУ 45216810,
      в особі директора Нагорної Віти Валентинівни, яка діє на підставі Статуту, пропонує необмеженому колу фізичних
      осіб (надалі – «Замовник»), укласти договір про надання послуг (надалі «Договір»).</p>
    <p>Даний Договір є публічним, відповідно до ст. ст. 633, 641 Цивільного кодексу України, та його умови є однакові
      для всіх Замовників.</p>

    <ol class="general-list">
      <li>
        Визначення термінів та загальні положення
        <ol>
          <li>Послуги – набір послуг, які надаються Виконавцем в порядку і на умовах, визначених цим Договором та
            умовах, зазначених на Сайті та телеграм-боті щодо послуги, яку замовляє Замовник. Інформація про Послугу
            розміщена на Сайті та в телеграм-боті Виконавця.
          </li>
          <li>Публічна оферта (далі – «Оферта», «Договір») – публічна пропозиція, адресована необмеженому колу фізичних
            осіб, укласти Договір на умовах, що містяться в цій Оферті.
          </li>
          <li>У цьому договорі Cайт Виконавця – це веб-сторінка в мережі Інтернет за адресою <a
            href="https://ev.land">https://ev.land</a>, яка є офіційним джерелом інформування Замовників про
            Виконавця та послуги, які їм надаються.
          </li>
          <li>У цьому договорі Телеграм-бот – це чат-бот в месенджері Telegram за посиланням <a
            href="https://t.me/evland_bot" target="_blank">https://t.me/evland_bot</a></li>
          <li>Акцепт – повне, безумовне і беззастережне прийняття Замовником умов в тому вигляді, в якому вони викладені
            в тексті цієї Оферти.
          </li>
          <li>Замовник – будь-яка дієздатна фізична особа, яка вчинила Акцепт цієї Оферти і сплатила вартість послуг
            Виконавця.
          </li>
          <li>Сторони – Виконавець та Замовник.</li>
          <li>Оферта – цей документ «Договір публічної оферти про надання послуг», розміщений у мережі інтернет за
            адресою <a href="https://ev.land/public-offer">https://ev.land/public-offer</a></li>
        </ol>
      </li>
      <li>
        Предмет договору.
        <ol>
          <li>Виконавець бере на себе зобов’язання надати Замовнику послуги, які останній замовляє на Сайті та/або в
            Телеграм-боті, а Замовник зобов’язується прийняти та здійснити оплату таких послуг.
          </li>
          <li>Сторони домовилися, що детальний зміст Послуги зазначається на Сайті Виконавця та/або в Телеграм-боті.
          </li>
          <li>Сторони погоджуються, що Виконавець не гарантує будь-яких інших результатів застосування Замовником
            Послуг, придбаних у Виконавця, у своїй діяльності.
          </li>
          <li>Ніякі претензії за результативністю застосування Замовником інформації, отриманої в результаті надання
            Виконавцем Послуг, не можуть бути пред’явлені Виконавцеві.
          </li>
          <li>Погоджуючись з умовами Договору, Замовник підтверджує свою правоздатність та дієздатність, включаючи
            досягнення 18-річного віку, законне користування банківською платіжною карткою, а також усвідомлює
            відповідальність за зобов’язаннями, що покладаються на нього у результаті укладання цього Договору.
          </li>
        </ol>
      </li>
      <li>
        Умови надання послуг.
        <ol>
          <li>Форма надання Послуги, яку замовляє Замовник, зазначається на Сайті Виконавця та/або в Телеграм-боті.</li>
          <li>Замовник самостійно вибирає Послугу на Сайті Виконавця та/або Телеграм-боті і здійснює оплату. Акцептом
            цієї Оферти є заповнення онлайн-форми заявки на надання Послуги на Сайті Виконавця та/або в Телеграм-боті з
            наступною повною оплатою Замовником вартості відповідної Послуги і означає повне і беззастережне прийняття
            Замовником умов цієї Оферти і прирівнюється до власноручного підпису Замовника під Договором.
          </li>
          <li>З моменту зарахування грошових коштів на рахунок Виконавця, ця Оферта вважається акцептованою. З моменту
            акцепту цієї Оферти одностороння відмова Замовника від Договору є неможливою.
          </li>
          <li>Послуги за цим Договором надаються в дистанційному форматі шляхом надсилання результатів надання Послуги
            Замовнику у спосіб, вибраний Замовником при замовленні Послуги.
          </li>
          <li>Послуга вважається наданою з моменту надсилання Виконавцем результатів надання Послуги Замовнику.</li>
        </ol>
      </li>
      <li>
        Права і обов’язки Виконавця:
        <ol>
          <li>
            Виконавець має право:
            <ol>
              <li>Самостійно організовувати процес надання Послуг Замовнику, визначати всі необхідні умови надання
                Послуг на власний розсуд.
              </li>
              <li>Отримувати від Замовника інформацію, необхідну для надання Послуг за цим Договором.</li>
              <li>Отримати за надані Послуги оплату в розмірах і строки, передбачених цим Договором та інформацією,
                розміщеною на Сайті та/або в Телеграм-боті.
              </li>
              <li>Змінювати вартість, строки на спосіб надання Послуг в будь-який час шляхом розміщення відповідних змін
                на Сайті та/або в Телеграм-боті.
              </li>
              <li>Опублікувати будь-які матеріали та відгуки, створені Замовником в процесі отримання Послуги, без
                будь-яких обмежень або компенсації на користь Замовника.
              </li>
            </ol>
          </li>
          <li>
            Виконавець зобов’язується:
            <ol>
              <li>Надавати Замовнику Послуги відповідно до цього Договору та інформації про послугу, розміщеної на Сайті
                та/або Телеграм-боті.
              </li>
              <li>Збирати та обробляти персональні дані Замовника відповідно до Правил користування сайтом, розміщених у
                мережі інтернет за адресою <a href="https://ev.land/terms-and-conditions">https://ev.land/terms-and-conditions</a>
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <li>
        Права та обов’язки Замовника.
        <ol>
          <li>
            Замовник має право:
            <ol>
              <li>Отримати послуги належної якості відповідно до умов цього договору та умов надання Послуги, розміщених
                на Сайті та/або Телеграм-боті.
              </li>
              <li>У будь-який час знайомитися з умовами надання Послуг, розміщеними на Сайті та/або Телеграм-боті
                Виконавця.
              </li>
            </ol>
          </li>
          <li>
            Замовник зобов’язується:
            <ol>
              <li>Вказувати достовірну, повну і точну інформацію про себе при заповненні заявки на надання Послуг та/або
                реєстрації на Сайті Виконавця. Якщо інформація в заявці виявиться недостовірною, Виконавець не несе
                відповідальності за неможливість встановлення зв’язку з Замовником і надання послуг за даним Договором.
              </li>
              <li>Своєчасно вносити плату за Послуги в розмірах і в строки, встановлені цим Договором.</li>
              <li>Дотримуватися Правил користування сайтом, розміщених у мережі інтернет за адресою <a
                href="https://ev.land/terms-and-conditions">https://ev.land/terms-and-conditions</a></li>
              <li>Виконувати вимоги чинного законодавства та вимоги Договору, пов’язані з наданням Послуг.</li>
              <li>Не порушувати права інтелектуальної власності Виконавця.</li>
            </ol>
          </li>
        </ol>
      </li>
      <li>
        Вартість послуг і порядок оплати.
        <ol>
          <li>Загальна вартість послуг, наданих Замовником за цим Договором складається із загальної суми сплачених
            Замовником Послуг.
          </li>
          <li>Вартість конкретної Послуги визначається Виконавцем на власний розсуд та розміщується на Сайті та/або
            Телеграм-боті Виконавця або ж повідомляється працівником Виконавця особисто Замовнику.
          </li>
          <li>Вартість передбачених цим Договором послуг оплачується Замовником на умовах 100% передоплати шляхом
            перерахування безготівкових грошових коштів на рахунок Виконавця або за допомогою оплати на Сайті та/або в
            Телеграм-боті.
          </li>
          <li>Послуги вважаються сплаченими з моменту надходження грошових коштів на рахунок Виконавця.</li>
        </ol>
      </li>
      <li>
        Відповідальність Сторін.
        <ol>
          <li>За невиконання або неналежне виконання зобов’язань за цим договором сторони несуть відповідальність
            відповідно до чинного законодавства.
          </li>
          <li>Послуги Виконавця і всі пов’язані матеріали надаються «як є», без будь-яких гарантій, явних чи неявних.
            Виконавець не надає ніяких гарантій, в тому числі комерційної придатності, придатності для певних цілей і
            непорушення прав третіх осіб, а також гарантій, що випливають з ділових відносин або звичаїв ділового
            обороту.
          </li>
          <li>У максимально дозволеною законодавством мірою Виконавець не несе відповідальності за непрямі, побічні,
            фактичні, непрямі або прямі збитки, прямо або побічно упущену вигоду або неотримання доходів, втрату даних,
            експлуатаційних якостей або інших нематеріальних цінностей Замовника. Ні в якому разі сума сукупної
            відповідальності за всіма претензіями щодо Послуг не може перевищувати вартості Послуги, отриманої від
            Замовника.
          </li>
          <li>Замовник погоджується, що відмова від гарантій і обмеження відповідальності, викладені в даних умовах,
            відображають розумний і справедливий розподіл ризиків, а також є необхідною умовою для надання послуг
            Виконавцем.
          </li>
          <li>Виконавець не несе відповідальності за невідповідність наданих Послуг очікуванням Замовника</li>
          <li>Виконавець не несе відповідальності за досягнення результатів, пов'язаних з практичним використанням
            Замовником інформації, одержаної в процесі надання Виконавцем Послуг, передбачених цим Договором.
          </li>
        </ol>
      </li>
      <li>
        Форс-мажор.
        <ol>
          <li>Сторони звільняються від відповідальності за повне або часткове невиконання зобов’язань, якщо це
            невиконання викликане обставинами, що не залежать від волі Сторін, а саме: військовими діями, стихійним
            лихом, техногенними та іншими аваріями, страйками, локаутами, актами органів влади або управління тощо, що
            унеможливлює виконання умов цього Договору (далі Форс-мажор).
          </li>
          <li>Форс-мажор застосовується, і Сторона, для якої він настав звільняється від відповідальності за порушення
            умов цього Договору, при наявності письмового підтвердження настання форс-мажорних обставин.
          </li>
          <li>Сторона, для якої наступили вказані обставини, зобов’язується негайно повідомити іншу Сторону та надати
            відповідні підтверджувальні документи.
          </li>
          <li>З моменту отримання такого повідомлення іншою стороною виконання умов даного Договору припиняється на весь
            період дії Форс-мажору.
          </li>
          <li>У разі дії Форс-мажорних обставин більше 3 (трьох) місяців, кожна Сторона має право ініціювати припинення
            Договору.
          </li>
        </ol>
      </li>
      <li>
        Строк дії оферти.
        <ol>
          <li>Ця Оферта набуває чинності з моменту її розміщення на Сайті Виконавця і діє до моменту її відкликання
            Виконавцем.
          </li>
          <li>Виконавець має право в будь-який час внести зміни в умови Оферти та/або відкликати Оферту в будь-який
            момент на свій розсуд. У разі внесення Виконавцем змін в Оферту, такі зміни вступають в силу з моменту
            розміщення зміненого тексту Оферти на Сайті Виконавця, якщо інший термін вступу змін в силу не визначений
            безпосередньо в тексті зміненої Оферти.
          </li>
          <li>Ця Публічна оферта є чинною з 28 березня 2024 року.</li>
        </ol>
      </li>
      <li>
        Заключні положення.
        <ol>
          <li>Сторони встановили, що будь-які спори і претензії будуть вирішуватися шляхом переговорів.</li>
          <li>Сторони усвідомлюють, що послуги надаються Виконавцем, який зареєстрований і діє відповідно до
            законодавства України.
          </li>
          <li>Місцем укладання договору і місцем надання послуг Сторони домовилися вважати місце знаходження Виконавця,
            вказане в розділі 11 цього Договору.
          </li>
          <li>Акцептуючи дану Оферту Замовник погоджується, що всі суперечки, пов’язані з цим Договором, будуть
            розглядатися відповідно до законодавства України.
          </li>
          <li>Заголовки, що використовуються в статтях і пунктах цієї Оферти, використовуються тільки для посилань і
            зручності користування текстом. Дані заголовки не можуть розглядатися як визначальні, що обмежують або
            змінюють, або впливають на значення і зміст умов цієї Оферти чи її будь-якої частини.
          </li>
          <li>Сторони цього Договору вирішили, що в разі визнання частини цього Договору недійсною (незаконною), сам
            Договір і без включення в нього недійсної (незаконної) частини вважається укладеним. В цьому випадку Сторона
            цього Договору не може посилатися на те, що без включення недійсної (незаконний) частини в Договір вона б
            його не уклала.
          </li>
          <li>Все викладене, становить єдиний текст Договору, який замінює всі попередні</li>
          <li>У всіх випадках, які не передбачені цією офертою, Сторони керуються чинним законодавством України.</li>
        </ol>
      </li>
      <li>
        Реквізити Виконавця.<br />
        <p>Товариство з обмеженою відповідальністю «ЧАРДЖ СПАЙ»<br />
          Адреса: 04216, місто Київ, вул.Газопровідна, будинок 43<br />
          п/р UA283057490000026001000019952, Банк АТ «Банк Кредит Дніпро», МФО 305749,<br />
          Код за ЄДРПОУ 45216810</p>
      </li>
    </ol>
  </ng-container>
</div>
